import React from 'react'
import MobileCarousel from '../../components/carousel/mobile-carousel'
import BenefitCard from './BenefitCard'

const MobileBenefitsView = ({
  setSectionActive,
  sections,
  initialPosition
}) => (
  <MobileCarousel
    setSectionActive={setSectionActive}
    initialPosition={initialPosition}
  >
    {sections.map((benefit, index) => (
      <BenefitCard
        key={benefit.id}
        index={index}
        {...benefit}
        section={benefit}
        onClick={() => {}}
      />
    ))}
  </MobileCarousel>
)

export default MobileBenefitsView
